export interface FactTile {
    label: string;
    value: string;
}

export interface CandidateFact {
    label: string;
    value: string | null;
}

// A fact with nothing known is dropped, so a tile grid only ever shows real values.
export function knownFacts(candidates: readonly CandidateFact[]): FactTile[] {
    return candidates.filter((fact): fact is FactTile => fact.value !== null);
}
